/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AppAtChar123handleChar125RouteImport } from './routes/_app/@{$handle}'
import { Route as AppFriendsRouteImport } from './routes/_app/friends'
import { Route as AppHomeRouteImport } from './routes/_app/home'
import { Route as AppInsightsRouteImport } from './routes/_app/insights'
import { Route as AppNewRouteImport } from './routes/_app/new'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppReadingRouteImport } from './routes/_app/reading'
import { Route as AppReflectRouteImport } from './routes/_app/reflect'
import { Route as AppResourcesRouteImport } from './routes/_app/resources'
import { Route as AppSavedRouteImport } from './routes/_app/saved'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppAuthorsIndexRouteImport } from './routes/_app/authors/index'
import { Route as AppAuthorsIdRouteImport } from './routes/_app/authors/$id'
import { Route as AppBibleIdRouteImport } from './routes/_app/bible/$id'
import { Route as AppBooksIdRouteImport } from './routes/_app/books/$id'
import { Route as AppICodeRouteImport } from './routes/_app/i.$code'
import { Route as AppLibraryIndexRouteImport } from './routes/_app/library.index'
import { Route as AppLibraryIdRouteImport } from './routes/_app/library.$id'
import { Route as AppLibraryPurchasedRouteImport } from './routes/_app/library.purchased'
import { Route as AppPPostIdRouteImport } from './routes/_app/p.$postId'
import { Route as AppPlansIndexRouteImport } from './routes/_app/plans/index'
import { Route as AppPlansJourneyIdRouteImport } from './routes/_app/plans/$journeyId'
import { Route as AppPlansNewRouteImport } from './routes/_app/plans/new'
import { Route as AppRRefRouteImport } from './routes/_app/r.$ref'
import { Route as AppBooksIdSectionRouteImport } from './routes/_app/books/$id_.$section'
import { Route as AppPlansAboutPlanIdRouteImport } from './routes/_app/plans/about.$planId'
import { Route as AppPlansJoinCodeRouteImport } from './routes/_app/plans/join.$code'
import { Route as AppBibleIdBookChapterRouteImport } from './routes/_app/bible/$id_.$book.$chapter'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAtChar123handleChar125Route =
  AppAtChar123handleChar125RouteImport.update({
    id: '/@{$handle}',
    path: '/@{$handle}',
    getParentRoute: () => AppRoute,
  } as any)
const AppFriendsRoute = AppFriendsRouteImport.update({
  id: '/friends',
  path: '/friends',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsRoute = AppInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppRoute,
} as any)
const AppNewRoute = AppNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppReadingRoute = AppReadingRouteImport.update({
  id: '/reading',
  path: '/reading',
  getParentRoute: () => AppRoute,
} as any)
const AppReflectRoute = AppReflectRouteImport.update({
  id: '/reflect',
  path: '/reflect',
  getParentRoute: () => AppRoute,
} as any)
const AppResourcesRoute = AppResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AppRoute,
} as any)
const AppSavedRoute = AppSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppAuthorsIndexRoute = AppAuthorsIndexRouteImport.update({
  id: '/authors/',
  path: '/authors/',
  getParentRoute: () => AppRoute,
} as any)
const AppAuthorsIdRoute = AppAuthorsIdRouteImport.update({
  id: '/authors/$id',
  path: '/authors/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppBibleIdRoute = AppBibleIdRouteImport.update({
  id: '/bible/$id',
  path: '/bible/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppBooksIdRoute = AppBooksIdRouteImport.update({
  id: '/books/$id',
  path: '/books/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppICodeRoute = AppICodeRouteImport.update({
  id: '/i/$code',
  path: '/i/$code',
  getParentRoute: () => AppRoute,
} as any)
const AppLibraryIndexRoute = AppLibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => AppRoute,
} as any)
const AppLibraryIdRoute = AppLibraryIdRouteImport.update({
  id: '/library/$id',
  path: '/library/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppLibraryPurchasedRoute = AppLibraryPurchasedRouteImport.update({
  id: '/library/purchased',
  path: '/library/purchased',
  getParentRoute: () => AppRoute,
} as any)
const AppPPostIdRoute = AppPPostIdRouteImport.update({
  id: '/p/$postId',
  path: '/p/$postId',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansIndexRoute = AppPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansJourneyIdRoute = AppPlansJourneyIdRouteImport.update({
  id: '/plans/$journeyId',
  path: '/plans/$journeyId',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansNewRoute = AppPlansNewRouteImport.update({
  id: '/plans/new',
  path: '/plans/new',
  getParentRoute: () => AppRoute,
} as any)
const AppRRefRoute = AppRRefRouteImport.update({
  id: '/r/$ref',
  path: '/r/$ref',
  getParentRoute: () => AppRoute,
} as any)
const AppBooksIdSectionRoute = AppBooksIdSectionRouteImport.update({
  id: '/books/$id_/$section',
  path: '/books/$id/$section',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansAboutPlanIdRoute = AppPlansAboutPlanIdRouteImport.update({
  id: '/plans/about/$planId',
  path: '/plans/about/$planId',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansJoinCodeRoute = AppPlansJoinCodeRouteImport.update({
  id: '/plans/join/$code',
  path: '/plans/join/$code',
  getParentRoute: () => AppRoute,
} as any)
const AppBibleIdBookChapterRoute = AppBibleIdBookChapterRouteImport.update({
  id: '/bible/$id_/$book/$chapter',
  path: '/bible/$id/$book/$chapter',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/rules': typeof RulesRoute
  '/sign-in': typeof SignInRoute
  '/welcome': typeof WelcomeRoute
  '/@{$handle}': typeof AppAtChar123handleChar125Route
  '/friends': typeof AppFriendsRoute
  '/home': typeof AppHomeRoute
  '/insights': typeof AppInsightsRoute
  '/new': typeof AppNewRoute
  '/notifications': typeof AppNotificationsRoute
  '/reading': typeof AppReadingRoute
  '/reflect': typeof AppReflectRoute
  '/resources': typeof AppResourcesRoute
  '/saved': typeof AppSavedRoute
  '/settings': typeof AppSettingsRoute
  '/authors/$id': typeof AppAuthorsIdRoute
  '/bible/$id': typeof AppBibleIdRoute
  '/books/$id': typeof AppBooksIdRoute
  '/i/$code': typeof AppICodeRoute
  '/library/$id': typeof AppLibraryIdRoute
  '/library/purchased': typeof AppLibraryPurchasedRoute
  '/p/$postId': typeof AppPPostIdRoute
  '/plans/$journeyId': typeof AppPlansJourneyIdRoute
  '/plans/new': typeof AppPlansNewRoute
  '/r/$ref': typeof AppRRefRoute
  '/authors/': typeof AppAuthorsIndexRoute
  '/library/': typeof AppLibraryIndexRoute
  '/plans/': typeof AppPlansIndexRoute
  '/books/$id/$section': typeof AppBooksIdSectionRoute
  '/plans/about/$planId': typeof AppPlansAboutPlanIdRoute
  '/plans/join/$code': typeof AppPlansJoinCodeRoute
  '/bible/$id/$book/$chapter': typeof AppBibleIdBookChapterRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/rules': typeof RulesRoute
  '/sign-in': typeof SignInRoute
  '/welcome': typeof WelcomeRoute
  '/@{$handle}': typeof AppAtChar123handleChar125Route
  '/friends': typeof AppFriendsRoute
  '/home': typeof AppHomeRoute
  '/insights': typeof AppInsightsRoute
  '/new': typeof AppNewRoute
  '/notifications': typeof AppNotificationsRoute
  '/reading': typeof AppReadingRoute
  '/reflect': typeof AppReflectRoute
  '/resources': typeof AppResourcesRoute
  '/saved': typeof AppSavedRoute
  '/settings': typeof AppSettingsRoute
  '/authors/$id': typeof AppAuthorsIdRoute
  '/bible/$id': typeof AppBibleIdRoute
  '/books/$id': typeof AppBooksIdRoute
  '/i/$code': typeof AppICodeRoute
  '/library/$id': typeof AppLibraryIdRoute
  '/library/purchased': typeof AppLibraryPurchasedRoute
  '/p/$postId': typeof AppPPostIdRoute
  '/plans/$journeyId': typeof AppPlansJourneyIdRoute
  '/plans/new': typeof AppPlansNewRoute
  '/r/$ref': typeof AppRRefRoute
  '/authors': typeof AppAuthorsIndexRoute
  '/library': typeof AppLibraryIndexRoute
  '/plans': typeof AppPlansIndexRoute
  '/books/$id/$section': typeof AppBooksIdSectionRoute
  '/plans/about/$planId': typeof AppPlansAboutPlanIdRoute
  '/plans/join/$code': typeof AppPlansJoinCodeRoute
  '/bible/$id/$book/$chapter': typeof AppBibleIdBookChapterRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/admin': typeof AdminRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/rules': typeof RulesRoute
  '/sign-in': typeof SignInRoute
  '/welcome': typeof WelcomeRoute
  '/_app/@{$handle}': typeof AppAtChar123handleChar125Route
  '/_app/friends': typeof AppFriendsRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/insights': typeof AppInsightsRoute
  '/_app/new': typeof AppNewRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/reading': typeof AppReadingRoute
  '/_app/reflect': typeof AppReflectRoute
  '/_app/resources': typeof AppResourcesRoute
  '/_app/saved': typeof AppSavedRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/authors/$id': typeof AppAuthorsIdRoute
  '/_app/bible/$id': typeof AppBibleIdRoute
  '/_app/books/$id': typeof AppBooksIdRoute
  '/_app/i/$code': typeof AppICodeRoute
  '/_app/library/$id': typeof AppLibraryIdRoute
  '/_app/library/purchased': typeof AppLibraryPurchasedRoute
  '/_app/p/$postId': typeof AppPPostIdRoute
  '/_app/plans/$journeyId': typeof AppPlansJourneyIdRoute
  '/_app/plans/new': typeof AppPlansNewRoute
  '/_app/r/$ref': typeof AppRRefRoute
  '/_app/authors/': typeof AppAuthorsIndexRoute
  '/_app/library/': typeof AppLibraryIndexRoute
  '/_app/plans/': typeof AppPlansIndexRoute
  '/_app/books/$id_/$section': typeof AppBooksIdSectionRoute
  '/_app/plans/about/$planId': typeof AppPlansAboutPlanIdRoute
  '/_app/plans/join/$code': typeof AppPlansJoinCodeRoute
  '/_app/bible/$id_/$book/$chapter': typeof AppBibleIdBookChapterRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/contact'
    | '/privacy'
    | '/rules'
    | '/sign-in'
    | '/welcome'
    | '/@{$handle}'
    | '/friends'
    | '/home'
    | '/insights'
    | '/new'
    | '/notifications'
    | '/reading'
    | '/reflect'
    | '/resources'
    | '/saved'
    | '/settings'
    | '/authors/$id'
    | '/bible/$id'
    | '/books/$id'
    | '/i/$code'
    | '/library/$id'
    | '/library/purchased'
    | '/p/$postId'
    | '/plans/$journeyId'
    | '/plans/new'
    | '/r/$ref'
    | '/authors/'
    | '/library/'
    | '/plans/'
    | '/books/$id/$section'
    | '/plans/about/$planId'
    | '/plans/join/$code'
    | '/bible/$id/$book/$chapter'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/contact'
    | '/privacy'
    | '/rules'
    | '/sign-in'
    | '/welcome'
    | '/@{$handle}'
    | '/friends'
    | '/home'
    | '/insights'
    | '/new'
    | '/notifications'
    | '/reading'
    | '/reflect'
    | '/resources'
    | '/saved'
    | '/settings'
    | '/authors/$id'
    | '/bible/$id'
    | '/books/$id'
    | '/i/$code'
    | '/library/$id'
    | '/library/purchased'
    | '/p/$postId'
    | '/plans/$journeyId'
    | '/plans/new'
    | '/r/$ref'
    | '/authors'
    | '/library'
    | '/plans'
    | '/books/$id/$section'
    | '/plans/about/$planId'
    | '/plans/join/$code'
    | '/bible/$id/$book/$chapter'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/admin'
    | '/contact'
    | '/privacy'
    | '/rules'
    | '/sign-in'
    | '/welcome'
    | '/_app/@{$handle}'
    | '/_app/friends'
    | '/_app/home'
    | '/_app/insights'
    | '/_app/new'
    | '/_app/notifications'
    | '/_app/reading'
    | '/_app/reflect'
    | '/_app/resources'
    | '/_app/saved'
    | '/_app/settings'
    | '/_app/authors/$id'
    | '/_app/bible/$id'
    | '/_app/books/$id'
    | '/_app/i/$code'
    | '/_app/library/$id'
    | '/_app/library/purchased'
    | '/_app/p/$postId'
    | '/_app/plans/$journeyId'
    | '/_app/plans/new'
    | '/_app/r/$ref'
    | '/_app/authors/'
    | '/_app/library/'
    | '/_app/plans/'
    | '/_app/books/$id_/$section'
    | '/_app/plans/about/$planId'
    | '/_app/plans/join/$code'
    | '/_app/bible/$id_/$book/$chapter'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AdminRoute: typeof AdminRoute
  ContactRoute: typeof ContactRoute
  PrivacyRoute: typeof PrivacyRoute
  RulesRoute: typeof RulesRoute
  SignInRoute: typeof SignInRoute
  WelcomeRoute: typeof WelcomeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/@{$handle}': {
      id: '/_app/@{$handle}'
      path: '/@{$handle}'
      fullPath: '/@{$handle}'
      preLoaderRoute: typeof AppAtChar123handleChar125RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/friends': {
      id: '/_app/friends'
      path: '/friends'
      fullPath: '/friends'
      preLoaderRoute: typeof AppFriendsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/insights': {
      id: '/_app/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AppInsightsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/new': {
      id: '/_app/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof AppNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reading': {
      id: '/_app/reading'
      path: '/reading'
      fullPath: '/reading'
      preLoaderRoute: typeof AppReadingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reflect': {
      id: '/_app/reflect'
      path: '/reflect'
      fullPath: '/reflect'
      preLoaderRoute: typeof AppReflectRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/resources': {
      id: '/_app/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AppResourcesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/saved': {
      id: '/_app/saved'
      path: '/saved'
      fullPath: '/saved'
      preLoaderRoute: typeof AppSavedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/authors/': {
      id: '/_app/authors/'
      path: '/authors'
      fullPath: '/authors/'
      preLoaderRoute: typeof AppAuthorsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/authors/$id': {
      id: '/_app/authors/$id'
      path: '/authors/$id'
      fullPath: '/authors/$id'
      preLoaderRoute: typeof AppAuthorsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bible/$id': {
      id: '/_app/bible/$id'
      path: '/bible/$id'
      fullPath: '/bible/$id'
      preLoaderRoute: typeof AppBibleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/books/$id': {
      id: '/_app/books/$id'
      path: '/books/$id'
      fullPath: '/books/$id'
      preLoaderRoute: typeof AppBooksIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/i/$code': {
      id: '/_app/i/$code'
      path: '/i/$code'
      fullPath: '/i/$code'
      preLoaderRoute: typeof AppICodeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library/': {
      id: '/_app/library/'
      path: '/library'
      fullPath: '/library/'
      preLoaderRoute: typeof AppLibraryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library/$id': {
      id: '/_app/library/$id'
      path: '/library/$id'
      fullPath: '/library/$id'
      preLoaderRoute: typeof AppLibraryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library/purchased': {
      id: '/_app/library/purchased'
      path: '/library/purchased'
      fullPath: '/library/purchased'
      preLoaderRoute: typeof AppLibraryPurchasedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/p/$postId': {
      id: '/_app/p/$postId'
      path: '/p/$postId'
      fullPath: '/p/$postId'
      preLoaderRoute: typeof AppPPostIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plans/': {
      id: '/_app/plans/'
      path: '/plans'
      fullPath: '/plans/'
      preLoaderRoute: typeof AppPlansIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plans/$journeyId': {
      id: '/_app/plans/$journeyId'
      path: '/plans/$journeyId'
      fullPath: '/plans/$journeyId'
      preLoaderRoute: typeof AppPlansJourneyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plans/new': {
      id: '/_app/plans/new'
      path: '/plans/new'
      fullPath: '/plans/new'
      preLoaderRoute: typeof AppPlansNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/r/$ref': {
      id: '/_app/r/$ref'
      path: '/r/$ref'
      fullPath: '/r/$ref'
      preLoaderRoute: typeof AppRRefRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/books/$id_/$section': {
      id: '/_app/books/$id_/$section'
      path: '/books/$id/$section'
      fullPath: '/books/$id/$section'
      preLoaderRoute: typeof AppBooksIdSectionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plans/about/$planId': {
      id: '/_app/plans/about/$planId'
      path: '/plans/about/$planId'
      fullPath: '/plans/about/$planId'
      preLoaderRoute: typeof AppPlansAboutPlanIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plans/join/$code': {
      id: '/_app/plans/join/$code'
      path: '/plans/join/$code'
      fullPath: '/plans/join/$code'
      preLoaderRoute: typeof AppPlansJoinCodeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bible/$id_/$book/$chapter': {
      id: '/_app/bible/$id_/$book/$chapter'
      path: '/bible/$id/$book/$chapter'
      fullPath: '/bible/$id/$book/$chapter'
      preLoaderRoute: typeof AppBibleIdBookChapterRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAtChar123handleChar125Route: typeof AppAtChar123handleChar125Route
  AppFriendsRoute: typeof AppFriendsRoute
  AppHomeRoute: typeof AppHomeRoute
  AppInsightsRoute: typeof AppInsightsRoute
  AppNewRoute: typeof AppNewRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppReadingRoute: typeof AppReadingRoute
  AppReflectRoute: typeof AppReflectRoute
  AppResourcesRoute: typeof AppResourcesRoute
  AppSavedRoute: typeof AppSavedRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppAuthorsIdRoute: typeof AppAuthorsIdRoute
  AppBibleIdRoute: typeof AppBibleIdRoute
  AppBooksIdRoute: typeof AppBooksIdRoute
  AppICodeRoute: typeof AppICodeRoute
  AppLibraryIdRoute: typeof AppLibraryIdRoute
  AppLibraryPurchasedRoute: typeof AppLibraryPurchasedRoute
  AppPPostIdRoute: typeof AppPPostIdRoute
  AppPlansJourneyIdRoute: typeof AppPlansJourneyIdRoute
  AppPlansNewRoute: typeof AppPlansNewRoute
  AppRRefRoute: typeof AppRRefRoute
  AppAuthorsIndexRoute: typeof AppAuthorsIndexRoute
  AppLibraryIndexRoute: typeof AppLibraryIndexRoute
  AppPlansIndexRoute: typeof AppPlansIndexRoute
  AppBooksIdSectionRoute: typeof AppBooksIdSectionRoute
  AppPlansAboutPlanIdRoute: typeof AppPlansAboutPlanIdRoute
  AppPlansJoinCodeRoute: typeof AppPlansJoinCodeRoute
  AppBibleIdBookChapterRoute: typeof AppBibleIdBookChapterRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAtChar123handleChar125Route: AppAtChar123handleChar125Route,
  AppFriendsRoute: AppFriendsRoute,
  AppHomeRoute: AppHomeRoute,
  AppInsightsRoute: AppInsightsRoute,
  AppNewRoute: AppNewRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppReadingRoute: AppReadingRoute,
  AppReflectRoute: AppReflectRoute,
  AppResourcesRoute: AppResourcesRoute,
  AppSavedRoute: AppSavedRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppAuthorsIdRoute: AppAuthorsIdRoute,
  AppBibleIdRoute: AppBibleIdRoute,
  AppBooksIdRoute: AppBooksIdRoute,
  AppICodeRoute: AppICodeRoute,
  AppLibraryIdRoute: AppLibraryIdRoute,
  AppLibraryPurchasedRoute: AppLibraryPurchasedRoute,
  AppPPostIdRoute: AppPPostIdRoute,
  AppPlansJourneyIdRoute: AppPlansJourneyIdRoute,
  AppPlansNewRoute: AppPlansNewRoute,
  AppRRefRoute: AppRRefRoute,
  AppAuthorsIndexRoute: AppAuthorsIndexRoute,
  AppLibraryIndexRoute: AppLibraryIndexRoute,
  AppPlansIndexRoute: AppPlansIndexRoute,
  AppBooksIdSectionRoute: AppBooksIdSectionRoute,
  AppPlansAboutPlanIdRoute: AppPlansAboutPlanIdRoute,
  AppPlansJoinCodeRoute: AppPlansJoinCodeRoute,
  AppBibleIdBookChapterRoute: AppBibleIdBookChapterRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AdminRoute: AdminRoute,
  ContactRoute: ContactRoute,
  PrivacyRoute: PrivacyRoute,
  RulesRoute: RulesRoute,
  SignInRoute: SignInRoute,
  WelcomeRoute: WelcomeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
